import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import * as BrandActions from './brands.actions';
import { DataService } from '../../services/data-api.service';

@Injectable()
export class BrandsEffects {
  constructor(private actions$: Actions, private dataService: DataService) {}

  loadBrands$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BrandActions.loadBrands), // When loadBrands action is dispatched
      mergeMap(() =>
        this.dataService.getBrands().pipe(
          map((brands) =>  { return BrandActions.loadBrandsSuccess({ brands })}),
          catchError((error) => of(BrandActions.loadBrandsFailure({ error })))
        )
      )
    )
  );
}
